let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kFAkd")).then(() => parcelRequire('19gyG'));